import {Distance} from '../../Domain/Distance';
import {Duration} from '../../Domain/Duration';
import {Speed} from '../../Domain/Speed';
import {getCategoryIndex} from './getCategoryIndex';
import {GeoSegment} from '../geoTrackToSegments';

export const mergeCategorisedSegments = (
    leftIndex: number,
    rightIndex: number,
    categorisedSegments: Array<{segments: GeoSegment[]; categoryIndex: number; avgSpeed: Speed}>,
    categories: Array<{index: number; rangeMin: number; rangeMax: number}>,
): Array<{segments: GeoSegment[]; categoryIndex: number; avgSpeed: Speed}> => {
    const entries = categorisedSegments[leftIndex].segments.concat(categorisedSegments[rightIndex].segments);
    const avgSpeed = Speed.fromDistanceAndDuration(
        Distance.fromMillimeters(
            categorisedSegments[leftIndex].segments
                .concat(categorisedSegments[rightIndex].segments)
                .map((s) => s.distance.millimeters)
                .flat()
                .reduce((sum, distance) => sum + distance),
        ),
        Duration.fromMilliseconds(
            categorisedSegments[leftIndex].segments
                .concat(categorisedSegments[rightIndex].segments)
                .map((s) => s.duration.milliseconds)
                .flat()
                .reduce((sum, duration) => sum + duration),
        ),
    );
    const categoryIndex = getCategoryIndex(categories, avgSpeed);
    return categorisedSegments
        .slice(0, leftIndex)
        .concat({segments: entries, categoryIndex: categoryIndex, avgSpeed: avgSpeed})
        .concat(categorisedSegments.slice(rightIndex + 1));
};
